import {
  AppStatusIncident,
  AppStatusIncidentStatus,
} from '@src/main/modules/app_status/domain/appStatusIncident.model';
import { formatDateCustom } from '@src/main/shared/utils/dateUtils';

export const APP_STATUS_TABLE_PREVIEW_LENGTH = 20;

export const statusClassNames: Record<AppStatusIncidentStatus, string> = {
  investigating: 'status-investigating',
  needsInfo: 'status-needs-info',
  nextVersion: 'status-next-version',
  resolved: 'status-resolved',
};

export const emptyIncident = (): AppStatusIncident => ({
  code: '',
  date: formatDateCustom(new Date()),
  errorDescription: '',
  errorDescriptionImage: null,
  errorDescriptionImageUrl: null,
  id: '',
  possibleSolution: '',
  possibleSolutionImage: null,
  possibleSolutionImageUrl: null,
  public: false,
  visibleApp: false,
  severity: 'medium',
  status: 'investigating',
  summary: '',
  title: '',
  version: '',
});

export const truncateAppStatusText = (
  value: string,
  maxLength = APP_STATUS_TABLE_PREVIEW_LENGTH,
) => (value.length > maxLength ? `${value.slice(0, maxLength)}...` : value);
